export default __webpack_public_path__ + "static/media/calendar_full_mock.ce9e1099.png";